import { createContext } from 'react';
import { LoginUserContextType } from '../types';

export const LoginUserContext = createContext({} as LoginUserContextType);
